import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { useMinimizedModalsContext } from '../../../hooks'
import { FormModalConfirmation } from '../../Form'
import { MinimizedModalsTray } from '../MinimizedModalsTray'

import { getConfirmationProps } from './MinimizedModals.utils'

function MinimizedModals() {
  const { clearAll, confirmation, hideConfirmation } =
    useMinimizedModalsContext()

  const { pathname } = useLocation()

  useEffect(() => {
    clearAll()
  }, [pathname])

  function handleConfirmationCancel(...args) {
    confirmation.onCancel?.(...args)
    hideConfirmation()
  }

  function handleConfirmationSubmit(...args) {
    // Hide first: a chained `confirmBeforeAction` submit may set the next
    // confirmation, which must not be clobbered by this cleanup.
    hideConfirmation()
    confirmation.onSubmit?.(...args)
  }

  const ConfirmationComponent = confirmation?.Component ?? FormModalConfirmation

  return (
    <>
      <MinimizedModalsTray />
      {confirmation ? (
        <ConfirmationComponent
          {...getConfirmationProps(confirmation)}
          onCancel={handleConfirmationCancel}
          onSubmit={handleConfirmationSubmit}
        />
      ) : null}
    </>
  )
}

export default MinimizedModals
